/**
 * Copyright Highway9 Networks Inc.
 */
import { useMemo, type ReactNode } from "react";
import { useAppSelector } from "~/store/hooks";
import { selectUserPermssions } from "~/store/context/authSlice";
import { AbilityContext } from "./AbilityContext";
import { defineAbilityFromPermissionsMap } from "./defineAbility";

type Props = {
  children: ReactNode;
};

/**
 * Syncs CASL ability with Redux user permissions (loaded in onAppStart via userService.getUserPermissions).
 */
export function AbilityProvider({ children }: Props) {
  const permissionsMap = useAppSelector(selectUserPermssions);
  const ability = useMemo(
    () => defineAbilityFromPermissionsMap(permissionsMap),
    [permissionsMap]
  );

  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
}
